import React from "react";
import { AuraType } from "../../types/game";
import { ORB_IMG } from "../../constants/league";
import { C } from "../../constants/design";

interface OrbIconProps {
  type: AuraType;
  size?: number;
  /** Compteur affiché en badge iOS (coin haut-droit). Affiche 0 si vide (badge gris). */
  count?: number;
  /** Force le grisé à 30% d'opacité indépendamment du compteur. */
  dim?: boolean;
}

/** Orbe PNG sans fond + badge compteur style iOS (haut-droit). */
export function OrbIcon({ type, size = 44, count, dim }: OrbIconProps) {
  const isEmpty = count != null && count === 0;
  const showBadge = count != null;
  return (
    <div
      style={{
        position: "relative",
        width: size,
        height: size,
        opacity: dim || isEmpty ? 0.35 : 1,
        flexShrink: 0,
      }}
    >
      <img
        src={ORB_IMG[type]}
        alt={type}
        width={size}
        height={size}
        style={{ display: "block", objectFit: "contain" }}
      />
      {showBadge && (
        <span
          style={{
            position: "absolute",
            top: -5,
            right: -5,
            minWidth: 17,
            height: 17,
            padding: "0 4px",
            borderRadius: 999,
            background: isEmpty ? "rgba(120,120,120,0.9)" : "#fff",
            color: isEmpty ? "#fff" : "#111",
            fontSize: 10.5,
            fontWeight: 900,
            lineHeight: "17px",
            textAlign: "center",
            boxShadow: "0 0 0 2px " + C.surface,
            fontFamily: "system-ui, sans-serif",
          }}
        >
          {count}
        </span>
      )}
    </div>
  );
}
